import { Link } from "react-router-dom";
import { hotArticles } from "@/mocks/home";

const articleImages: Record<string, string> = {
  "article-1": "https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20community%20forum%20illustration%20with%20soft%20coral%20and%20peach%20tones%2C%20modern%20Chinese%20web%20design%20aesthetic%2C%20clean%20and%20minimal%20composition%2C%20friendly%20atmosphere%2C%20digital%20community%20concept%20art%2C%20gentle%20gradients%20and%20soft%20shadows%2C%20welcoming%20visual%20style&width=800&height=400&seq=hot-article-01&orientation=landscape",
  "article-2": "https://readdy.ai/api/search-image?query=A%20group%20of%20friendly%20people%20connecting%20in%20a%20warm%20digital%20community%20space%2C%20soft%20peach%20and%20coral%20color%20palette%2C%20modern%20flat%20illustration%20style%2C%20cozy%20and%20welcoming%20atmosphere%2C%20Chinese%20community%20website%20aesthetic&width=800&height=400&seq=hot-article-02&orientation=landscape",
  "article-3": "https://readdy.ai/api/search-image?query=A%20fresh%20and%20modern%20digital%20platform%20update%20concept%2C%20smooth%20gradients%20in%20warm%20peach%20tones%2C%20minimalist%20UI%20elements%2C%20clean%20and%20bright%20composition%2C%20technology%20meets%20warmth%2C%20soft%20lighting%20and%20gentle%20curves&width=800&height=400&seq=hot-article-03&orientation=landscape",
  "article-4": "https://readdy.ai/api/search-image?query=A%20secure%20shield%20concept%20with%20warm%20protective%20glow%2C%20soft%20coral%20and%20amber%20accent%20colors%2C%20digital%20security%20illustration%20with%20friendly%20aesthetic%2C%20modern%20Chinese%20design%20style%2C%20reassuring%20and%20trustworthy%20atmosphere&width=800&height=400&seq=hot-article-04&orientation=landscape",
  "article-5": "https://readdy.ai/api/search-image?query=A%20heartwarming%20collection%20of%20handwritten%20letters%20and%20messages%20floating%20in%20a%20warm%20glowing%20space%2C%20soft%20pink%20and%20coral%20tones%2C%20emotional%20connection%20concept%2C%20gentle%20romantic%20atmosphere%2C%20dreamy%20bokeh%20effects&width=800&height=400&seq=hot-article-05&orientation=landscape",
  "article-6": "https://readdy.ai/api/search-image?query=A%20creative%20personal%20space%20customization%20concept%2C%20warm%20peach%20and%20coral%20color%20scheme%2C%20digital%20profile%20design%20illustration%2C%20modern%20minimal%20style%2C%20friendly%20and%20inviting%20visual%2C%20soft%20shadows%20and%20clean%20layout&width=800&height=400&seq=hot-article-06&orientation=landscape",
};

export default function HomeHotArticles() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-14">
          <div>
            <span className="inline-block bg-accent-100 text-accent-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
              热门推荐
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              精选内容
            </h2>
            <p className="text-foreground-500 text-sm">社区达人都在看的热门文章</p>
          </div>
          <Link
            to="/category/qinggan-jiaoliu"
            className="mt-4 sm:mt-0 text-sm font-medium text-primary-500 hover:text-primary-600 flex items-center gap-1.5 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {hotArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden hover:bg-background-50 transition-all duration-300"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={articleImages[article.id]}
                  alt={article.title}
                  title={`${article.title} - 爱情岛论坛`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3 flex-wrap">
                  <span className="text-xs font-medium bg-primary-50 text-primary-600 px-2.5 py-1 rounded-full">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 leading-snug mb-3 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {article.readCount.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i> {article.commentCount.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}